/**
 * Central route configuration.
 * To add a new route, simply add it here with the route path and optional parameter builder.
 */

import type { BuilderStep } from 'shared/consts';

export const routes = {
  home: () => '/',
  login: () => '/auth/login',
  forgotPassword: () => '/auth/forgot-password',
  resetPassword: () => '/auth/reset-password',
  verifyEmail: () => '/auth/verify-email',
  signUp: () => '/auth/sign-up',
  signUpWithId: (id: string | number) => ({
    to: '/auth/sign-up/$id',
    params: { id: String(id) }
  }),
  updateBusinessDetails: () => '/get-started/update-business-details',
  findLocation: () => '/get-started/find-location',
  addKeywords: () => '/get-started/add-keywords',
  addPrompts: () => '/get-started/add-prompts',
  gettingInsights: () => '/get-started/getting-insights',
  locations: () => '/locations',
  /** The way into Account settings: opens the first section. */
  account: () => '/account/profile',
  accountProfile: () => '/account/profile',
  accountSecurity: () => '/account/security',
  accountCompany: () => '/account/company',
  accountUsers: () => '/account/users',
  addLocation: () => '/locations/add',
  addLocationKeywords: (locationId: number, placeId: string) => ({
    to: '/locations/add/keywords',
    search: { locationId, placeId }
  }),
  addLocationPrompts: (locationId: number, placeId: string) => ({
    to: '/locations/add/prompts',
    search: { locationId, placeId }
  }),
  locationSummary: (id: string | number) => ({
    to: '/locations/$id/summary',
    params: { id: String(id) }
  }),
  aiVisibility: (id: string | number) => ({
    to: '/locations/$id/ai-visibility',
    params: { id: String(id) }
  }),
  aiVisibilitySettings: (id: string | number) => ({
    to: '/locations/$id/ai-visibility/settings',
    params: { id: String(id) }
  }),
  localSearchGrid: (id: string | number) => ({
    to: '/locations/$id/lsg',
    params: { id: String(id) }
  }),
  localSearchGridSettings: (id: string | number) => ({
    to: '/locations/$id/lsg/settings',
    params: { id: String(id) }
  }),
  localRankTracker: (id: string | number) => ({
    to: '/locations/$id/lrt',
    params: { id: String(id) }
  }),
  labs: (id: string | number) => ({
    to: '/locations/$id/labs',
    params: { id: String(id) }
  }),
  lab: (id: string | number, labId: string) => ({
    to: '/locations/$id/labs/$labId',
    params: { id: String(id), labId }
  }),
  reviewTracker: (id: string | number) => ({
    to: '/locations/$id/reviews/tracker',
    params: { id: String(id) }
  }),
  gbpInsights: (id: string | number) => ({
    to: '/locations/$id/gbp/insights',
    params: { id: String(id) }
  }),
  reviewManager: (id: string | number) => ({
    to: '/locations/$id/reviews/manager',
    params: { id: String(id) }
  }),
  replyTemplates: (id: string | number) => ({
    to: '/locations/$id/reviews/manager/templates',
    params: { id: String(id) }
  }),
  cbCampaign: (locationId: number, campaignId: number) => ({
    to: '/locations/$id/cb/campaign/$campaignId/edit',
    params: { id: locationId, campaignId }
  }),
  cbCampaignEditStep: (locationId: number, campaignId: number, step: BuilderStep) => ({
    to: '/locations/$id/cb/campaign/$campaignId/edit/$step',
    params: { id: locationId, campaignId, step }
  })
};
